import { render, staticRenderFns } from "./quantity.vue?vue&type=template&id=5c668a16"
import script from "./quantity.vue?vue&type=script&lang=js"
export * from "./quantity.vue?vue&type=script&lang=js"
import style0 from "./quantity.vue?vue&type=style&index=0&id=5c668a16&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c668a16')) {
      api.createRecord('5c668a16', component.options)
    } else {
      api.reload('5c668a16', component.options)
    }
    module.hot.accept("./quantity.vue?vue&type=template&id=5c668a16", function () {
      api.rerender('5c668a16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/suppliers/fields/quantity.vue"
export default component.exports